import dayjs from '@/localPlugins/dayjs';

export const getLocalDateFormat = (format = 'L') => {
  return dayjs().locale(navigator.language).localeData().longDateFormat(format).replace(/MMMM/g, 'MMM');
};